import '../style/exchange.css';
import CurrencyInput from "./CurrencyInput";
import { useState, useEffect } from "react";

export default function Exchange() {
  const [amount1, setAmount1] = useState(1);
  const [amount2, setAmount2] = useState(1);
  const [currency1, setCurrency1] = useState('EUR');  // Default input currency set to EUR
  const [currency2, setCurrency2] = useState('USD');  // Default output currency set to USD
  const [rates, setRates] = useState({});
  const [copyMessage, setCopyMessage] = useState('');

  useEffect(() => {
    async function fetchRates() {
      try {
        const res = await fetch(
          'https://data.fixer.io/api/latest?access_key=7d018667759aa74bd388ceaeb2785c46&format=1'
        );
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        setRates(data.rates);
      } catch (error) {
        console.error("Failed to fetch exchange rates:", error);
      }
    }

    fetchRates();
  }, []);

  useEffect(() => {
    if (Object.keys(rates).length > 0) {
      const calculatedAmount2 = (1 * rates[currency2]) / rates[currency1];
      setAmount1(1);
      setAmount2(format(calculatedAmount2));
    }
  }, [rates, currency1, currency2]);

  function format(number) {
    return number.toFixed(4);
  }

  function handleAmount1Change(amount1) {
    setAmount2(format((amount1 * rates[currency2]) / rates[currency1]));
    setAmount1(amount1);
  }

  function handleCurrency1Change(currency1) {
    setAmount2(format((amount1 * rates[currency2]) / rates[currency1]));
    setCurrency1(currency1);
  }

  function handleAmount2Change(amount2) {
    setAmount1(format((amount2 * rates[currency1]) / rates[currency2]));
    setAmount2(amount2);
  }

  function handleCurrency2Change(currency2) {
    setAmount1(format((amount2 * rates[currency1]) / rates[currency2]));
    setCurrency2(currency2);
  }

  function copyToClipboard(value) {
    navigator.clipboard.writeText(value)
      .then(() => {
        setCopyMessage('Value copied to clipboard!');
        setTimeout(() => setCopyMessage(''), 2000);
      })
      .catch((error) => console.error('Error copying value:', error));
  }

  return (
    <div className='exchange'>
      <h1>Currency Converter</h1>
      <CurrencyInput
        onAmountChange={handleAmount1Change}
        onCurrencyChange={handleCurrency1Change}
        currencies={Object.keys(rates)}
        amount={amount1}
        currency={currency1}
      />
      <CurrencyInput
        onAmountChange={handleAmount2Change}
        onCurrencyChange={handleCurrency2Change}
        currencies={Object.keys(rates)}
        amount={amount2}
        currency={currency2}
      />
      <div className="copy-section">
        <button onClick={() => copyToClipboard(amount2)}>Copy Value</button>
        {copyMessage && <span className="copy-message">{copyMessage}</span>}
      </div>
    </div>
  );
}
